if (!window.Eurus.loadedScript.has('philosophy-story.js')) {
  window.Eurus.loadedScript.add('philosophy-story.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPhilosophyStory', () => ({
        craftActiveIndex: 0,

        init() {
          this.$el.classList.add('philosophy-story--enhanced');

          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.observeActs();
          this.observeReveals();
          this.observeProof();
          this.observeCraft();
          this.observeVisionAccent();
          this.setupOpeningVideo(prefersReducedMotion);
        },

        observeActs() {
          const backdrop = this.$el.querySelector('.philosophy-story__backdrop');
          const acts = this.$el.querySelectorAll('[data-act-bg]');
          if (!acts.length) return;

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-active');
                if (backdrop) {
                  backdrop.style.backgroundColor = entry.target.dataset.actBg;
                }
              }
            });
          }, { threshold: 0.5 });

          acts.forEach((act) => observer.observe(act));
        },

        observeReveals() {
          const items = this.$el.querySelectorAll('.reveal');
          if (!items.length) return;

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.35 });

          items.forEach((item) => observer.observe(item));
        },

        observeProof() {
          const proof = this.$el.querySelector('.philosophy-proof');
          if (!proof) return;

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.4 });

          observer.observe(proof);
        },

        observeCraft() {
          const triggers = this.$el.querySelectorAll('.philosophy-craft__trigger');
          const lines = this.$el.querySelectorAll('.philosophy-craft__line');
          if (!triggers.length || !lines.length) return;

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Number(entry.target.dataset.craftIndex || 0);
                lines.forEach((line) => {
                  line.classList.toggle('is-active', Number(line.dataset.craftIndex) === index);
                });
              }
            });
          }, { threshold: 0.5 });

          triggers.forEach((trigger) => observer.observe(trigger));
        },

        observeVisionAccent() {
          // Propre à cette seule ligne : contrairement à .reveal (une fois pour
          // toutes), elle apparaît ET disparaît avec le scroll, pour ne jamais
          // rester figée hors champ ni être manquée si on remonte la page.
          const el = this.$el.querySelector('.philosophy-vision__accent-line');
          if (!el) return;

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              entry.target.classList.toggle('is-visible', entry.isIntersecting);
            });
          }, { threshold: 0.4 });

          observer.observe(el);
        },

        setupOpeningVideo(prefersReducedMotion) {
          const videos = this.$el.querySelectorAll('.philosophy-video-frame video');
          if (!videos.length || prefersReducedMotion) return;

          videos.forEach((video) => {
            video.muted = true;
            const tryPlayIfVisible = () => {
              if (video.offsetParent !== null) {
                video.play().catch(() => {});
              }
            };

            if (video.readyState >= 2) {
              tryPlayIfVisible();
            } else {
              video.addEventListener('loadeddata', tryPlayIfVisible, { once: true });
            }
          });
        }
      }));
    });
  });
}
